import { DataSourceDataTypeMap } from '@core/models';

export function hasPreviousValue(element: { previous_data?: any }, fieldName: string): boolean {
  return !!element.previous_data && Object.prototype.hasOwnProperty.call(element.previous_data, fieldName);
}

export function getPreviousValueTooltip(element: any, fieldName: string, tableDescription: boolean = false): string {
  let currentValue = element[fieldName];
  let previousValue = element.previous_data?.[fieldName];

  if (fieldName === 'data_type' && typeof previousValue === 'string') {
    previousValue = DataSourceDataTypeMap.get(previousValue.toLowerCase()) ?? previousValue;
  }

  const displayValue = (value: any) => (typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value);

  if (previousValue !== undefined && previousValue !== currentValue) {
    if (tableDescription) {
      return `Previous description: ${displayValue(previousValue)}`;
    }
    return `${displayValue(currentValue)}\n\nPrevious data: ${displayValue(previousValue)}`;
  }
  return displayValue(currentValue);
}
